export enum TypeEvenementCalendrier {
	EVENEMENT = 'EVENEMENT',
	RESERVATION = 'RESERVATION'
}
